import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Header from './header';
import ByLine from './by_line';
import Article from './article';
import Footer from './footer';
import Social from '../../social/social';
import Live from '../../live/live';
import getByLineAttribution from '../../../../utils/by_line_util';

export default class Body extends Component {
  componentDidMount() {
    const id = get(this.props, 'post.id', '');
    const postWrapper = document.querySelector(`.post__body[data-id="${id}"]`);

    if (id && postWrapper) {
      const article = postWrapper.querySelector('.post__article');
      this.hashAnchors = article.querySelectorAll('a[href^="#"]');

      Array.prototype.forEach.call(this.hashAnchors, anchor => {
        anchor.addEventListener('click', this.windowToHash, false);
      });
    }
  }

  componentWillUnmount() {
    if (this.hashAnchors) {
      Array.prototype.forEach.call(this.hashAnchors, anchor => {
        anchor.removeEventListener('click', this.windowToHash, false);
      });
    }
  }

  windowToHash(event) {
    event.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));

    if (target) {
      window.scrollTo(0, target.offsetTop - 100);
    }
  }

  render() {
    const {
      post,
      advertorial,
      isFirstPost,
      combinedAdModel,
      videoAdData,
      config,
      pageNum,
      isLongPost,
      isVideoPost,
      hasNewsletter,
      related,
      live
    } = this.props;
    const { tags, content: article, layout } = post;
    const emptyContent = !get(article, 'length');
    const bylineAttribution = getByLineAttribution(tags);
    const postFiniteLive =
      !isFirstPost &&
      get(post, 'tags', []).filter(tag => tag.name.indexOf('live:') > -1)
        .length === 1;
    const hasLivePosts = Boolean(get(post, 'live.posts.length', false));

    return (
      <div className="post__body" data-id={post.id} data-slug={post.slug}>
        {layout === 'long' ? (
          <Header
            tags={tags}
            advertorial={advertorial}
            post={post}
            combinedAdModel={combinedAdModel}
            isFirstPost={isFirstPost}
            isLongPost={isLongPost}
            isVideoPost={isVideoPost}
            related={related}
            videoAdData={videoAdData}
            live={live || postFiniteLive}
            config={config}
          />
        ) : null}

        {isVideoPost ? (
          <Social
            enableSticky={this.props.isDesktop && isLongPost}
            empty={emptyContent}
            text={encodeURIComponent(get(post, 'title') || '')}
            uri={post.link}
            modifier="post-video"
            bottomBoundary={`#social--${post.id}`}
            encapsulateId={`social--${post.id}`}
          />
        ) : (
          <div className={`post__container post__container--${post.layout}`}>
            <Social
              enableSticky={this.props.isDesktop && isLongPost}
              empty={emptyContent}
              topValue={110}
              text={encodeURIComponent(get(post, 'title') || '')}
              uri={post.link}
              modifier="post"
              bottomBoundary={`#social--${post.id}`}
              encapsulateId={`social--${post.id}`}
            />

            <div className="post__content">
              {layout === 'short' ? (
                <Header
                  tags={tags}
                  advertorial={advertorial}
                  post={post}
                  combinedAdModel={combinedAdModel}
                  isFirstPost={isFirstPost}
                  isLongPost={isLongPost}
                  isVideoPost={isVideoPost}
                  related={related}
                  videoAdData={videoAdData}
                  live={live || postFiniteLive}
                  config={config}
                />
              ) : null}

              <ByLine
                post={post}
                bylineAttribution={bylineAttribution}
                live={hasLivePosts}
              />

              <Article
                config={config}
                advertorial={advertorial}
                post={post}
                combinedAdModel={combinedAdModel}
                pageNum={pageNum}
                isShortPost={!isLongPost}
              />

              {postFiniteLive ? (
                <a
                  className="post__live-link"
                  href={`/${post.id}/${post.slug}`}
                >
                  Follow Our Live Coverage
                </a>
              ) : null}

              {!live && !hasLivePosts ? (
                <Footer
                  post={post}
                  bylineAttribution={bylineAttribution}
                  isLongPost={isLongPost}
                  hasNewsletter={hasNewsletter}
                  config={config}
                />
              ) : null}

              {(isFirstPost && live) || hasLivePosts ? (
                <Live parentPost={post} live={post.live} config={config} />
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

Body.defaultProps = {
  isDesktop: false,
  hasNewsletter: false,
  isVideoPost: false,
  isLongPost: false,
  related: []
};

Body.propTypes = {
  post: PropTypes.shape({}).isRequired,
  advertorial: PropTypes.bool.isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  config: PropTypes.shape({}).isRequired,
  videoAdData: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  pageNum: PropTypes.number.isRequired,
  isLongPost: PropTypes.bool,
  hasNewsletter: PropTypes.bool,
  isVideoPost: PropTypes.bool,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  live: PropTypes.bool.isRequired
};
